import { inject, Injectable } from '@angular/core';
import { CKAuthService } from '@ck-core/ck-auth';

import { environment } from '../../../environments/environment';

@Injectable({ providedIn: 'root' })
export class SiteContextService {
    private readonly auth = inject(CKAuthService);

    /** Returns the active siteId for the current session. */
    get siteId(): string {
        const mimicSiteId = this.auth.authData?.moreInfo?.siteId;
        if (mimicSiteId) {
            return mimicSiteId;
        }
        return environment.siteId;
    }
}
